import { Component, Mixins, Prop, Watch } from 'vue-property-decorator'
import api from '@webparts/api/index'
import { LoadingBar } from '@appbase/components/loading'
import NoData from '@webparts/components/common/NoData.vue'
import WebpartBase from '@webparts/components/webparts/base/WebpartBase'
import WebpartTemplate from '@webparts/components/webparts/base/WebpartTemplate.vue'
import { mapGetters } from 'vuex'
import * as accouttypes from '@account/store/types'
import BannerSettingModal from '@webparts/components/webparts/HK/Popup/BannerSettingModal.vue'

import { buildStyle } from "@appbase/util/popup-helper"
import * as urlHelper from '@appbase/util/url-helper'

const notFound = "/cm/gres/faux/images/no_data.png";
const tempData = [{
  category : '카테고리1',
  title : '타이틀',
  inputDate : '표시날짜',
},{
  category : '카테고리2',
  title : '타이틀',
  inputDate : '표시날짜',
},{
  category : '카테고리3',
  title : '타이틀',
  inputDate : '표시날짜',
},{
  category : '카테고리4',
  title : '타이틀',
  inputDate : '표시날짜',
}]

@Component({
  name: 'banner-webpart',
  components: {
    LoadingBar,
    NoData,
    WebpartTemplate,
    BannerSettingModal
  },
  computed: mapGetters({
        current: accouttypes.CURRENT,
  }),
})

export default class BannerWebpart extends Mixins(WebpartBase) {
  @Prop({ type: Object }) webpart !: webpartv3.Webpart

  popupBaseUrl!: string;
  current!: account.TCurrent
  isBannerManager:boolean = false
  options : any=null

  bannerList: webpartBanner.Banner[] = []
  imagePath: string = '';
  page:number = 1
  totalPage:number = 0
  curBanner: webpartBanner.Banner|null = null
  intervalId: number = 0;
  intervalStartTime: number = new Date().getTime();
  timer:number = 5000


  created() {
    if (this.preview) {
      // preview일 때 보여질 테스트 데이터 작성
      this.curBanner = (tempData as any)[0]
      this.totalPage = 4
    } else 
    this.load()
  }

  beforeDestroy(){
    cancelAnimationFrame(this.intervalId)
  }

  async handleClick() {
    if (this.preview) return;

    var url = this.bannerList[this.page-1].linkUrl;
    var features = ''
    var target = '_blank'

    if (url.includes('api/processToken')) {
        var _url = new URL(url)

        var searchParams = _url.searchParams

        var redirect = searchParams.get("redirectUrl") ?? "_blank"
        _url.searchParams.delete("redirectUrl")

        var search: string[] = []
        search.push(`personCode=${this.current.user.personCode}`, `timeStamp=${new Date().getTime()}`)
        if (_url.search !== '') {
            var _search = _url.search.slice(1).split('&')
            search = search.concat(_search)
        }
        var params = this.getParams(search)

        url = this.isTeams ? await urlHelper.redirectWithProcessToken(redirect, params, this.current.user.comCode, this.current.key)
            : `${window.location.origin}${process.env.NODE_ENV === 'production' ? '/po' : ''}${redirect}`;
        target = redirect
        features = buildStyle({ width: 1024, height: 850 })
    }
    else if (url.includes(window.location.host)) {
      if(url.toLowerCase().includes('boardpopup')) {
        if(this.isTeams) {
          // To-do: 팀즈 모달 처리
          // 임시로 새 창으로 연결
        } else {
          features = buildStyle({ width: 1024, height: 850 });
        }
      } else {
        window.location.href = url
        return
      }
    }

    window.open(url, target, features);
  }

  getParams(search: string[]) {
    var res = ''

    for (var i = 0; i < search.length; i++) {
        res += `&${search[i]}`
    }

    if (res.startsWith('&'))
        res = res.slice(1)

    return res
}

  async load() {
    this.loading = true
    this.timer = Number(this.getAppConfig("WebzineTimer"))*1000
    if(this.current.permissions.roles.length>0){
      this.isBannerManager = this.current.permissions.isCompanyManager || this.current.permissions.isSuperAdmin || this.current.permissions.roles.find(i=>i.roleType.toLowerCase()=='banner')!=undefined
    }
    this.options = typeof(this.webpart.props) == typeof('') ? JSON.parse(this.webpart.props as string) : this.webpart.props;
    api.webpartData.getBannerList(this.current.user.comCode,this.options.isGlobal,this.webpart.id as string).then(res=>{
      if(res){
        this.bannerList = res
        // 처음 보여지는 배너를 랜덤으로 정해 달라는 교보문고의 요구사항 반영
        let randomIdx = Math.floor(Math.random() * this.bannerList.length);
        this.curBanner = this.bannerList[randomIdx]
        this.page = randomIdx + 1;
        this.totalPage = this.bannerList.length
        if(this.totalPage>1){
          this.repeatOften()
        }
      }
    })
    this.loading = false;
  }

  repeatOften(){
    // 5초마다 배너 넘김
    const callback =() =>{
      const currentTime = new Date().getTime();
      if((currentTime-this.timer)>this.intervalStartTime){
        this.changePage(1)
        this.intervalStartTime = new Date().getTime()
        this.intervalId = requestAnimationFrame(callback)
      }
      else{
        this.intervalId = requestAnimationFrame(callback)
      }
    }
    this.intervalId = requestAnimationFrame(callback)
  }

  changePage(val: number) {
    if (val < 0) {
        if(this.page == 1) {
          this.page = this.totalPage
        } else {
          this.page += val
        }
    } else {
      var img = this.$refs.bannerImg as HTMLImageElement
      img.style.opacity = '0'
      setTimeout(() => {
        if(val > 0 && this.page == this.totalPage) this.page = 1
        else this.page += val
      }, 500);
    }
  }

  openSettingModal(){
    const modal: appbase.IModalOpenable = this.$refs['modal'] as any
    const options: appbase.TModalInfo<any> = {
      component: BannerSettingModal,
      props: {comCode:this.current.user.comCode, isGlobalBanner:this.options.isGlobal, mappingId:this.webpart.id},
      events: {
        cancel: () => {
          modal.closeModal()
        },
      },
    }
    modal.openModal(options)
  }

  getTitleSplit(){
    return this.curBanner?.title.split('\n')
  }

  @Watch('page')
  reloadData(val: number) {
    if(this.preview)
    this.curBanner = (tempData as any)[val-1]
    else  
    this.curBanner = this.bannerList[val-1]
  }

  @Watch('curBanner')
  changeImagePath(banner:webpartBanner.Banner){
    this.imagePath =''
    if(this.preview) 
    this.imagePath = '/cm/gres/faux/images/portal/img-poster.png'
    else{
      if(banner){
        var img = this.$refs.bannerImg as HTMLImageElement
        this.imagePath = banner.filePath? banner.filePath : notFound
        img.style.opacity = '1'
      }
      else this.imagePath = ''
    }
  }

}
